document.addEventListener('submit',function(event){if(event.target.matches('[data-add-to-cart]')){const button=event.target.querySelector('button[type="submit"]');if(button){button.textContent='Adding…';button.disabled=true;}}});
(function(){
  var header=document.querySelector('.site-header');
  if(header){
    var updateHeader=function(){header.classList.toggle('is-scrolled',window.scrollY>56);};
    updateHeader();
    window.addEventListener('scroll',updateHeader,{passive:true});
  }
  var toggle=document.querySelector('[data-search-toggle]');
  var overlay=document.querySelector('[data-search-overlay]');
  var close=document.querySelector('[data-search-close]');
  var input=document.querySelector('[data-search-input]');
  if(!toggle||!overlay||!close||!input)return;
  function closeSearch(){overlay.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');setTimeout(function(){overlay.hidden=true;},200);}
  function openSearch(){overlay.hidden=false;requestAnimationFrame(function(){overlay.classList.add('is-open');});toggle.setAttribute('aria-expanded','true');setTimeout(function(){input.focus();},0);}
  toggle.addEventListener('click',openSearch);close.addEventListener('click',closeSearch);
  overlay.addEventListener('click',function(event){if(event.target===overlay)closeSearch();});
  document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!overlay.hidden)closeSearch();});
})();
(function(){
  function cleanLampDescription(root){
    var descriptions=root.querySelectorAll('.casa-product--lamps [data-product-description]');
    var emojiPattern=/[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\uFE0F\u200D\u20E3]/gu;
    descriptions.forEach(function(description){
      description.querySelectorAll('.comparison-table').forEach(function(table){table.remove();});
      description.querySelectorAll('img,picture').forEach(function(media){
        var parent=media.parentElement;
        var following=media.nextElementSibling;
        if(following&&following.tagName==='BR')following.remove();
        media.remove();
        if(parent&&parent!==description&&!parent.textContent.trim()&&!parent.querySelector('p,h1,h2,h3,h4,ul,ol,table,video,iframe'))parent.remove();
      });
      description.querySelectorAll('p').forEach(function(paragraph){
        if(/(?:the offer ends tonight|100% satisfaction guarantee)/i.test(paragraph.textContent))paragraph.remove();
      });
      var intro=description.firstElementChild;
      if(intro&&intro.tagName==='P'&&intro.firstElementChild&&intro.firstElementChild.tagName==='STRONG'&&intro.querySelector('br')){
        var lead=document.createElement('p');
        lead.className='casa-product__description-lead';
        lead.textContent=intro.firstElementChild.textContent.trim();
        intro.before(lead);
        intro.firstElementChild.remove();
        intro.querySelector('br').remove();
      }
      var walker=document.createTreeWalker(description,NodeFilter.SHOW_TEXT);
      var node;
      while((node=walker.nextNode())){
        node.nodeValue=node.nodeValue.replace(emojiPattern,'');
      }
    });
  }
  cleanLampDescription(document);
  document.addEventListener('shopify:section:load',function(event){cleanLampDescription(event.target);});
})();
document.addEventListener('DOMContentLoaded',function(){
  var cards=document.querySelectorAll('.product-card--reveal');
  if(!cards.length||!('IntersectionObserver' in window)){cards.forEach(function(card){card.classList.add('is-visible');});return;}
  var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -28px'});
  cards.forEach(function(card){observer.observe(card);});
});
document.addEventListener('click',function(event){var thumb=event.target.closest('[data-gallery-thumb]');if(!thumb)return;var main=document.querySelector('[data-product-gallery-main]');if(main)main.src=thumb.dataset.full;document.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.classList.remove('is-active');});thumb.classList.add('is-active');});
(function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var nav=document.querySelector('[data-menu-drawer]');
  var scrim=document.querySelector('[data-menu-scrim]');
  var close=document.querySelector('[data-menu-close]');
  if(!toggle||!nav||!scrim)return;
  function closeMenu(){nav.classList.remove('is-open');nav.setAttribute('aria-hidden','true');scrim.classList.remove('is-visible');scrim.hidden=true;toggle.setAttribute('aria-expanded','false');}
  function openMenu(){nav.classList.add('is-open');nav.setAttribute('aria-hidden','false');scrim.hidden=false;requestAnimationFrame(function(){scrim.classList.add('is-visible');});toggle.setAttribute('aria-expanded','true');}
  toggle.addEventListener('click',function(){nav.classList.contains('is-open')?closeMenu():openMenu();});
  scrim.addEventListener('click',closeMenu);
  if(close)close.addEventListener('click',closeMenu);
  nav.addEventListener('click',function(event){if(event.target.tagName==='A')closeMenu();});
})();
(function(){
  var rail=document.querySelector('[data-review-rail]');
  if(!rail)return;
  var prev=document.querySelector('[data-review-prev]');
  var next=document.querySelector('[data-review-next]');
  var originals=Array.prototype.slice.call(rail.children);
  if(!originals.length)return;
  var beforeFragment=document.createDocumentFragment();
  var afterFragment=document.createDocumentFragment();
  originals.forEach(function(card){
    var before=card.cloneNode(true);
    var after=card.cloneNode(true);
    before.setAttribute('aria-hidden','true');
    after.setAttribute('aria-hidden','true');
    before.removeAttribute('data-shopify-editor-block');
    after.removeAttribute('data-shopify-editor-block');
    beforeFragment.appendChild(before);
    afterFragment.appendChild(after);
  });
  rail.insertBefore(beforeFragment,rail.firstChild);
  rail.appendChild(afterFragment);
  var firstOriginal=originals[0];
  var firstAfter=rail.children[originals.length*2];
  var mobileCenter=function(card){return window.matchMedia('(max-width: 760px)').matches?card.offsetLeft-(rail.clientWidth-card.getBoundingClientRect().width)/2:card.offsetLeft;};
  var start=mobileCenter(firstOriginal);
  var loopWidth=firstAfter.offsetLeft-firstOriginal.offsetLeft;
  var timer;
  var step=function(){return originals[0].getBoundingClientRect().width+18;};
  function jumpTo(position){
    rail.style.scrollBehavior='auto';
    rail.scrollLeft=position;
    requestAnimationFrame(function(){rail.style.scrollBehavior='';});
  }
  function normalise(){
    if(rail.scrollLeft<start-step()/2)jumpTo(rail.scrollLeft+loopWidth);
    else if(rail.scrollLeft>=start+loopWidth-step()/2)jumpTo(rail.scrollLeft-loopWidth);
  }
  jumpTo(start);
  rail.addEventListener('scroll',function(){clearTimeout(timer);timer=setTimeout(normalise,90);},{passive:true});
  rail.addEventListener('scrollend',normalise);
  if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});
  window.addEventListener('resize',function(){
    start=mobileCenter(firstOriginal);
    loopWidth=firstAfter.offsetLeft-firstOriginal.offsetLeft;
    jumpTo(start);
  });
})();
(function(){
  var faqs=document.querySelectorAll('.casa-product__faq-list details');
  faqs.forEach(function(faq){
    faq.addEventListener('toggle',function(){
      if(!faq.open)return;
      faqs.forEach(function(other){if(other!==faq)other.open=false;});
    });
  });
})();
(function(){
  var storageKey='ciaraRecentlySeen';
  var product=document.querySelector('[data-recent-product]');
  try {
    var saved=JSON.parse(localStorage.getItem(storageKey)||'[]');
    if(product){
      var item={title:product.dataset.title,url:product.dataset.url,image:product.dataset.image,price:product.dataset.price,compare:product.dataset.compare||''};
      saved=[item].concat(saved.filter(function(entry){return entry.url!==item.url;})).slice(0,12);
      localStorage.setItem(storageKey,JSON.stringify(saved));
    }
    var section=document.querySelector('[data-recently-seen]');
    var rail=document.querySelector('[data-recently-seen-rail]');
    var next=document.querySelector('[data-recently-seen-next]');
    if(!section||!rail)return;
    if(!saved.length){
      var fallback=section.querySelector('[data-popular-products]');
      var recentTitle=section.querySelector('[data-recently-seen-title]');
      var popularTitle=section.querySelector('[data-popular-title]');
      if(fallback&&fallback.children.length){
        fallback.hidden=false;
        if(recentTitle)recentTitle.hidden=true;
        if(popularTitle)popularTitle.hidden=false;
        section.hidden=false;
        if(next)next.addEventListener('click',function(){fallback.scrollBy({left:fallback.clientWidth*.75,behavior:'smooth'});});
      }
      return;
    }
    saved.forEach(function(entry){
      var card=document.createElement('a');card.className='recently-seen__card';card.href=entry.url;
      var image=document.createElement('img');image.src=entry.image;image.alt=entry.title;image.loading='lazy';
      var title=document.createElement('span');title.className='recently-seen__title';title.textContent=entry.title;
      var price=document.createElement('span');price.className='recently-seen__price';
      var current=document.createElement('span');current.textContent=entry.price;price.appendChild(current);
      if(entry.compare){var compare=document.createElement('s');compare.textContent=entry.compare;price.appendChild(compare);}
      card.appendChild(image);card.appendChild(title);card.appendChild(price);rail.appendChild(card);
    });
    section.hidden=false;
    if(next)next.addEventListener('click',function(){rail.scrollBy({left:rail.clientWidth*.75,behavior:'smooth'});});
  } catch(error) {}
})();
(function(){
  var header=document.querySelector('.site-header');
  var spacer=document.querySelector('.site-header-spacer');
  if(!header||!spacer)return;
  var start=header.getBoundingClientRect().top+window.scrollY;
  function update(){
    var shouldFix=window.scrollY>start;
    header.classList.toggle('is-fixed',shouldFix);
    spacer.style.height=shouldFix?header.offsetHeight+'px':'';
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',function(){if(!header.classList.contains('is-fixed'))start=header.getBoundingClientRect().top+window.scrollY;update();});
  update();
})();
(function(){
  var select=document.querySelector('form[data-add-to-cart] select[name="id"]');
  if(!select)return;
  var productData=null;
  function money(cents){return '€'+(cents/100).toFixed(2).replace('.', ',');}
  function updateVariant(variantId){
    if(!productData)return;
    var variant=productData.variants.find(function(v){return String(v.id)===String(variantId);});
    if(!variant)return;
    var current=document.querySelector('.product-price__current');
    var compare=document.querySelector('.product-price__compare');
    var save=document.querySelector('.product-price__save');
    if(current)current.textContent=money(variant.price);
    if(variant.compare_at_price&&variant.compare_at_price>variant.price){
      if(compare){compare.textContent=money(variant.compare_at_price);compare.style.display='';}
      if(save){
        var pct=Math.round((1-variant.price/variant.compare_at_price)*100);
        save.textContent='Save '+pct+'%';
        save.style.display='';
      }
    }else{
      if(compare)compare.style.display='none';
      if(save)save.style.display='none';
    }
    var img=variant.featured_image?variant.featured_image.src:null;
    var main=document.querySelector('[data-product-gallery-main]');
    if(img&&main){
      main.src=img;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(b){
        b.classList.toggle('is-active', b.dataset.full && b.dataset.full.split('?')[0]===img.split('?')[0]);
      });
    }
    var addBtn=document.querySelector('form[data-add-to-cart] button[type="submit"]');
    if(addBtn){
      addBtn.disabled=!variant.available;
      addBtn.textContent=variant.available?'Add to bag':'Sold out';
    }
  }
  function findVariantByOptions(values){
    if(!productData)return null;
    return productData.variants.find(function(v){
      return values.every(function(val,i){return v.options[i]===val;});
    });
  }
  fetch(window.location.pathname.replace(/\/?$/, '')+'.js')
    .then(function(r){return r.json();})
    .then(function(data){
      productData=data;
      var optionSelects=document.querySelectorAll('variant-selects select[data-option-index]');
      if(optionSelects.length){
        var ordered=Array.prototype.slice.call(optionSelects).sort(function(a,b){
          return Number(a.dataset.optionIndex)-Number(b.dataset.optionIndex);
        });
        ordered.forEach(function(s){
          s.addEventListener('change',function(){
            var values=ordered.map(function(s){return s.value;});
            var variant=findVariantByOptions(values);
            if(variant){
              select.value=String(variant.id);
              updateVariant(variant.id);
            }
          });
        });
      }
    })
    .catch(function(){});
  select.addEventListener('change',function(){updateVariant(select.value);});
})();
(function(){
  var dialog=document.querySelector('[data-story-dialog]');
  if(!dialog)return;
  var image=dialog.querySelector('[data-story-dialog-image]');
  var caption=dialog.querySelector('[data-story-dialog-caption]');
  var close=dialog.querySelector('[data-story-close]');
  var previous=dialog.querySelector('[data-story-previous]');
  var next=dialog.querySelector('[data-story-next]');
  var count=dialog.querySelector('[data-story-count]');
  var progress=Array.prototype.slice.call(dialog.querySelectorAll('.casa-product__story-progress span'));
  var cards=Array.prototype.slice.call(document.querySelectorAll('[data-story-card]'));
  var index=0;
  var timer;
  function startTimer(){
    clearTimeout(timer);
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    timer=setTimeout(function(){show(index+1);},6000);
  }
  function show(nextIndex){
    if(!cards.length)return;
    if(nextIndex>=cards.length){closeDialog();return;}
    index=Math.max(0,nextIndex);
    var card=cards[index];
    image.src=card.dataset.storyImage||'';
    image.alt=card.querySelector('img')?card.querySelector('img').alt:'';
    caption.textContent=card.dataset.storyCaption||'';
    if(count)count.textContent=(index+1)+' / '+cards.length;
    var box=caption.parentNode;if(box)box.classList.toggle('is-empty',!caption.textContent);
    progress.forEach(function(bar,barIndex){bar.classList.remove('is-complete','is-active');if(barIndex<index)bar.classList.add('is-complete');});
    if(progress[index]){void progress[index].offsetWidth;progress[index].classList.add('is-active');}
    startTimer();
  }
  cards.forEach(function(card,cardIndex){
    card.addEventListener('click',function(){
      if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
      show(cardIndex);
    });
  });
  function closeDialog(){clearTimeout(timer);if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');}
  if(close)close.addEventListener('click',closeDialog);
  if(previous)previous.addEventListener('click',function(){show(index-1);});
  if(next)next.addEventListener('click',function(){show(index+1);});
  dialog.addEventListener('click',function(event){if(event.target===dialog)closeDialog();});
  dialog.addEventListener('close',function(){clearTimeout(timer);});
  document.addEventListener('keydown',function(event){if(!dialog.open)return;if(event.key==='ArrowLeft')show(index-1);if(event.key==='ArrowRight')show(index+1);});
})();
(function(){
  var rail=document.querySelector('[data-editorial-rail]');
  if(!rail)return;
  var prev=document.querySelector('[data-editorial-prev]');
  var next=document.querySelector('[data-editorial-next]');
  function step(){var item=rail.querySelector('figure');return item?item.getBoundingClientRect().width+18:360;}
  if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});
})();
(function(){
  var rail=document.querySelector('[data-product-media-rail]');
  if(!rail)return;
  var track=rail.querySelector('[data-product-media-track]');
  if(!track)return;
  var originals=Array.prototype.slice.call(track.children);
  var paused=false;
  var last=0;
  var loopWidth=0;
  var resumeTimer;
  var offset=0;
  var pointerStart;
  var offsetStart;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  originals.forEach(function(slide){
    var clone=slide.cloneNode(true);
    clone.setAttribute('aria-hidden','true');
    track.appendChild(clone);
  });
  function measure(){var firstClone=track.children[originals.length];loopWidth=firstClone?firstClone.offsetLeft:0;}
  function normalise(){if(!loopWidth)return;offset=((offset%loopWidth)+loopWidth)%loopWidth;}
  function render(){track.style.transform='translate3d(-'+offset+'px,0,0)';}
  function pause(){paused=true;window.clearTimeout(resumeTimer);}
  function resume(delay){window.clearTimeout(resumeTimer);resumeTimer=window.setTimeout(function(){paused=false;},delay||0);}
  function animate(now){
    if(!last)last=now;
    if(!paused&&!reduced&&loopWidth){
      offset+=(now-last)*.05808;
      normalise();
      render();
    }
    last=now;
    window.requestAnimationFrame(animate);
  }
  rail.addEventListener('pointerdown',function(event){pointerStart=event.clientX;offsetStart=offset;pause();rail.setPointerCapture(event.pointerId);});
  rail.addEventListener('pointermove',function(event){if(pointerStart===undefined)return;offset=offsetStart-(event.clientX-pointerStart);normalise();render();});
  function releasePointer(){pointerStart=undefined;resume(1400);}
  rail.addEventListener('pointerup',releasePointer);
  rail.addEventListener('pointercancel',releasePointer);
  window.addEventListener('resize',function(){measure();normalise();render();});
  measure();
  render();
  window.requestAnimationFrame(animate);
})();
(function(){
  var rail=document.querySelector('[data-customer-stories-rail]');
  if(!rail)return;
  var prev=document.querySelector('[data-customer-stories-prev]');
  var next=document.querySelector('[data-customer-stories-next]');
  var originals=Array.prototype.slice.call(rail.children);
  var loopEnabled=originals.length>1;
  var firstOriginal;
  var firstAfter;
  var start=0;
  var loopWidth=0;
  var timer;
  function step(){var card=rail.querySelector('.customer-stories__card');return card?card.getBoundingClientRect().width+14:rail.clientWidth*.82;}
  function jumpTo(position){rail.style.scrollBehavior='auto';rail.scrollLeft=position;requestAnimationFrame(function(){rail.style.scrollBehavior='';});}
  function normalise(){
    if(!loopEnabled)return;
    if(rail.scrollLeft<start-step()/2)jumpTo(rail.scrollLeft+loopWidth);
    else if(rail.scrollLeft>=start+loopWidth-step()/2)jumpTo(rail.scrollLeft-loopWidth);
  }
  if(loopEnabled){
    var beforeFragment=document.createDocumentFragment();
    var afterFragment=document.createDocumentFragment();
    originals.forEach(function(card){
      var before=card.cloneNode(true);
      var after=card.cloneNode(true);
      before.setAttribute('aria-hidden','true');
      after.setAttribute('aria-hidden','true');
      beforeFragment.appendChild(before);
      afterFragment.appendChild(after);
    });
    rail.insertBefore(beforeFragment,rail.firstChild);
    rail.appendChild(afterFragment);
    firstOriginal=originals[0];
    firstAfter=rail.children[originals.length*2];
    start=firstOriginal.offsetLeft;
    loopWidth=firstAfter.offsetLeft-firstOriginal.offsetLeft;
    jumpTo(start);
    rail.addEventListener('scroll',function(){clearTimeout(timer);timer=setTimeout(normalise,90);},{passive:true});
    rail.addEventListener('scrollend',normalise);
  }
  if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});
})();
(function(){
  var rail=document.querySelector('[data-discovery-rail]');
  if(!rail)return;
  var track=rail.querySelector('[data-discovery-track]');
  if(!track)return;
  var originals=Array.prototype.slice.call(track.children);
  if(!originals.length)return;
  var paused=false;
  var last=0;
  var loopWidth=0;
  var resumeTimer;
  var offset=0;
  var pointerStart;
  var offsetStart;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  originals.forEach(function(slide){
    var clone=slide.cloneNode(true);
    clone.setAttribute('aria-hidden','true');
    clone.querySelectorAll('a,button,[tabindex]').forEach(function(element){element.setAttribute('tabindex','-1');});
    track.appendChild(clone);
  });
  function measure(){var firstClone=track.children[originals.length];loopWidth=firstClone?firstClone.offsetLeft:0;}
  function normalise(){if(!loopWidth)return;offset=((offset%loopWidth)+loopWidth)%loopWidth;}
  function render(){track.style.transform='translate3d(-'+offset+'px,0,0)';}
  function pause(){paused=true;window.clearTimeout(resumeTimer);}
  function resume(delay){window.clearTimeout(resumeTimer);resumeTimer=window.setTimeout(function(){paused=false;},delay||0);}
  function animate(now){
    if(!last)last=now;
    if(!paused&&!reduced&&loopWidth){offset+=(now-last)*.05808;normalise();render();}
    last=now;
    window.requestAnimationFrame(animate);
  }
  rail.addEventListener('pointerdown',function(event){pointerStart=event.clientX;offsetStart=offset;pause();rail.setPointerCapture(event.pointerId);});
  rail.addEventListener('pointermove',function(event){if(pointerStart===undefined)return;offset=offsetStart-(event.clientX-pointerStart);normalise();render();});
  function releasePointer(){pointerStart=undefined;resume(1400);}
  rail.addEventListener('pointerup',releasePointer);
  rail.addEventListener('pointercancel',releasePointer);
  window.addEventListener('resize',function(){measure();normalise();render();});
  measure();
  render();
  window.requestAnimationFrame(animate);
})();
